const actions = {
  FETCH_ALERTS: "FETCH_ALERTS",
  VIEW_ALERT: "VIEW_ALERT",
  LOAD_SITE_LIST: "LOAD_SITE_LIST"
};

export default actions;